import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {LeadNatureModel} from '../Model/LeadNatureModel'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getLeadNatureSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getLeadNature, params)
    yield put(actions.getLeadNatureSuccess(response?.data?.data))
    yield put(actions.getLeadNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getLeadNatureFinish())
  }
}

function* getAllLeadNatureSaga() {
  try {
    const response: ResponseModel = yield call(service.getAllLeadNature)
    yield put(actions.getAllLeadNatureSuccess(response?.data?.data))
    yield put(actions.getAllLeadNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getAllLeadNatureFinish())
  }
}

function* addLeadNatureSaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addLeadNature, body)
    yield put(actions.addLeadNatureSuccess(response.data?.data))
    yield delay(100)
    yield put(actions.addLeadNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.addLeadNatureFinish())
  }
}

function* enableLeadNatureSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.enableLeadNature, selectedUsers)
    yield put(actions.enableLeadNatureSuccess(response?.data))
    yield delay(100)
    yield put(actions.enableLeadNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.enableLeadNatureFinish())
  }
}

function* disableLeadNatureSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.disableLeadNature, selectedUsers)
    yield put(actions.disableLeadNatureSuccess(response?.data))
    yield delay(100)
    yield put(actions.disableLeadNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.disableLeadNatureFinish())
  }
}

function* singleEnableLeadNatureSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleEnableLeadNature, selectedUsers)
    yield put(actions.singleEnableLeadNatureSuccess(response?.data))
    yield delay(100)
    yield put(actions.singleEnableLeadNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleEnableLeadNatureFinish())
  }
}

function* singleDisableLeadNatureSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleDisableLeadNature, selectedUsers)
    yield put(actions.singleDisableLeadNatureSuccess(response?.data))
    yield delay(100)
    yield put(actions.singleDisableLeadNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleDisableLeadNatureFinish())
  }
}

function* updateLeadNatureSaga(action: ActionModel) {
  try {
    const body: LeadNatureModel = action.payload
    const response: ResponseModel = yield call(
      service.updateLeadNature,
      body,
      (action as any).id
    )
    yield put(actions.updateLeadNatureSuccess(response.data?.data))
    yield put(actions.updateLeadNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateLeadNatureFinish())
  }
}

function* deleteLeadNatureSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteLeadNature, body)
    yield put(actions.deleteLeadNatureSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteLeadNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteLeadNatureFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_LEAD_NATURE_START, getLeadNatureSaga)
  yield takeLatest(actionTypes.GET_ALL_LEAD_NATURE_START, getAllLeadNatureSaga)
  yield takeLatest(actionTypes.ADD_LEAD_NATURE_START, addLeadNatureSaga)
  yield takeLatest(actionTypes.UPDATE_LEAD_NATURE_START, updateLeadNatureSaga)
  yield takeLatest(actionTypes.DELETE_LEAD_NATURE_START, deleteLeadNatureSaga)
  yield takeLatest(actionTypes.ENABLE_LEAD_NATURE_REQUEST, enableLeadNatureSaga)
  yield takeLatest(actionTypes.DISABLE_LEAD_NATURE_REQUEST, disableLeadNatureSaga)
  yield takeLatest(
    actionTypes.SINGLE_ENABLE_LEAD_NATURE_REQUEST,
    singleEnableLeadNatureSaga
  )
  yield takeLatest(
    actionTypes.SINGLE_DISABLE_LEAD_NATURE_REQUEST,
    singleDisableLeadNatureSaga
  )
}

